import axios from "axios";
import config from "config/index";
import { getGlobal } from "config/global";
let host = config.host + "/api/"
let apikey = config.apikey
// initializing the axios instance with custom configs
export default function uploadPanorama (file, address, id, night, progress) {
    let token = localStorage.getItem("token")
    let formData = new FormData();
    formData.append("image", file);
    formData.append("address", address);
    formData.append("id", id);
    if(night)
    formData.append("night", night);
    return axios.post(host + `tour/uploadimage`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "ApiKey": apikey,
            "Authorization": "Bearer " + token
        },
        onUploadProgress: progressEvent => {
            const { loaded, total } = progressEvent;
            let percent = Math.floor((loaded * 100) / total);
            if (percent < 100) {
                progress(percent)
            }
        }
    }).then((response) => {
        return response.data
    }).catch((err) => {
        if (err?.response?.status == 401)
            { localStorage.removeItem("token"); window.location=("/auth/signin"); return toast.error("لطفا مجددا لاگین کنید.", {position: "bottom-right"})}
        else
        throw err;
    })
}